import * as React from 'react';
import { read, WorkBook } from 'xlsx';
import {
  Box,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { Property, PROPERTIES, isProperty } from './parser/types';

export type UnifiedUploadResult = {
  fileData: Uint8Array;
  reportDate: Date;
  property: Property;
};

export type UnifiedUploadProps = {
  onUpload: (r: UnifiedUploadResult) => void;
};

function FileUpload({ onFileUpload }: { onFileUpload: (workbook: WorkBook, data: Uint8Array) => void }) {
  const handleFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const data = await file.arrayBuffer();
      const workbook = read(data);
      onFileUpload(workbook, new Uint8Array(data));
    }
  };

  return (
    <div>
      <input type="file" onChange={handleFile} />
    </div>
  );
}

export function UnifiedUpload({ onUpload }: UnifiedUploadProps) {
  const [workbook, setWorkbook] = React.useState<WorkBook | null>(null);
  const [fileData, setFileData] = React.useState<Uint8Array | null>(null);
  const [property, setProperty] = React.useState<Property | null>(null);
  const [reportDate, setReportDate] = React.useState(new Date());

  const handleFileUpload = (workbook: WorkBook, data: Uint8Array) => {
    setWorkbook(workbook);
    setFileData(data);
  };

  const handleParse = () => {
    if (fileData && property && reportDate) {
      onUpload({ fileData, reportDate, property });
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Stack>
        <FileUpload onFileUpload={handleFileUpload} />
        <div>
          <div>Propery Name</div>
          <Select
            label="Propery"
            value={property}
            onChange={(e) => {
              const v = e.target.value;
              if (v && isProperty(v)) {
                setProperty(v);
              }
            }}
          >
            {
              PROPERTIES.map((p) => (
                <MenuItem value={p} key={p}>
                  <em>{p}</em>
                </MenuItem>
              ))
            }
          </Select>
        </div>
        <div>
          <div>Report Date:</div>
          <input
            type="date"
            value={reportDate.toISOString().split('T')[0]}
            onChange={(e) => {
              try {
                // Make sure the entered date is valid.
                new Date(e.target.value).toISOString();

                setReportDate(new Date(e.target.value));
              } catch {
                // Do nothing - reject the input
              }
            }}
          />
        </div>
        <div>
          <button onClick={handleParse}>Parse</button>
        </div>
      </Stack>
    </Box>
  );
}
